import { WINDOW_WIDTH } from '@libs/interfaces/layouts'
import { useState, useEffect } from 'react';
import { ILayoutStore, useLayoutStore } from 'src/settings/zustand';

export interface IWindowDemention {
  width: number
  height: number
  layoutHeight: number
  dimention: keyof typeof WINDOW_WIDTH
}

function getWindowDimensions() : IWindowDemention {
  if(!window) {
    return { width: 1200, height: 968, layoutHeight: 760, dimention : "PANEL" }
  }
  
  const { innerWidth: width, innerHeight: height } = window
  const dems: string[] = Object.keys( WINDOW_WIDTH ).filter((v) => isNaN(Number(v)))
  
  const demention = dems.filter( (key: string, i: number) => {
    const max = WINDOW_WIDTH[ dems[ i ] as keyof typeof WINDOW_WIDTH ]
    const min = WINDOW_WIDTH[ (dems[ i + 1 ]) as keyof typeof WINDOW_WIDTH ]
    const bool: boolean =  window.innerWidth > min 
      && ( i < dems.length - 1
          ?
          window.innerWidth < max
          :
          true )
    return bool
  })
  return {
    width,
    height,
    dimention: ( demention[0] || "PANEL" ) as keyof typeof WINDOW_WIDTH,
    layoutHeight: height
  };
}
export default function useScreenSize( is_full:boolean=true ) {
  const headerHeight: number = useLayoutStore((state: ILayoutStore) => state.headerHeight)
  const footerHeight: number = useLayoutStore((state: ILayoutStore) => state.footerHeight)
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  function handleResize() {
    const dm: IWindowDemention = getWindowDimensions()
    setWindowDimensions( dm );
  }
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [])
  return {
    ...windowDimensions,
    layoutHeight: windowDimensions.height - ( is_full ? 0 : headerHeight + footerHeight ) 
  };
} 